/* Spec PWA-001 — tela 19 · preferencias de acessibilidade do aparelho. Funcoes puras. */

export const A11Y_STORAGE_KEY = 'gpd-a11y'

/* Escala do texto: o meio (indice 2) e o tamanho padrao do sistema. */
export const TEXT_SCALES = [0.875, 0.9375, 1, 1.125, 1.25] as const
export const DEFAULT_TEXT_SCALE_INDEX = 2

export type AccessibilityPrefs = {
    textScaleIndex: number
    highContrast: boolean
    reduceMotion: boolean
}

export const DEFAULT_A11Y: AccessibilityPrefs = {
    textScaleIndex: DEFAULT_TEXT_SCALE_INDEX,
    highContrast: false,
    reduceMotion: false,
}

export function parseA11y(raw: string | null): AccessibilityPrefs {
    if (!raw) return DEFAULT_A11Y
    try {
        const v = JSON.parse(raw) as Partial<AccessibilityPrefs>
        const idx = Number.isInteger(v.textScaleIndex) && v.textScaleIndex! >= 0 && v.textScaleIndex! < TEXT_SCALES.length
            ? v.textScaleIndex!
            : DEFAULT_TEXT_SCALE_INDEX
        return { textScaleIndex: idx, highContrast: v.highContrast === true, reduceMotion: v.reduceMotion === true }
    } catch {
        return DEFAULT_A11Y
    }
}

export function textScalePercent(index: number): number {
    return Math.round((TEXT_SCALES[index] ?? 1) * 100)
}

export function applyA11y(prefs: AccessibilityPrefs, root: HTMLElement = document.documentElement): void {
    root.style.fontSize = `${textScalePercent(prefs.textScaleIndex)}%`
    root.classList.toggle('a11y-contrast', prefs.highContrast)
    root.classList.toggle('a11y-reduce-motion', prefs.reduceMotion)
}
